import React from "react";
import {
  FlaskConical,
  ScrollText,
  IndianRupee,
  Landmark,
  ShieldCheck,
  Timer,
} from "lucide-react";
import "./WhyChooseUs.css";

const features = [
  {
    number: "01",
    icon: FlaskConical,
    title: "State-of-the-Art Testing",
    description:
      "The most advanced karat-meter technology inspects your gold non-destructively for a precise, honest purity reading — no scratching, no acid, no guesswork.",
    hasImage: true,
  },
  {
    number: "02",
    icon: ScrollText,
    title: "Radical Transparency",
    description:
      "Watch every step of the evaluation live. You see the weight, purity and rate before you decide.",
  },
  {
    number: "03",
    icon: IndianRupee,
    title: "Instant Cash Payout",
    description:
      "Accept the offer and walk out with cash the same visit. No delays, no deductions.",
  },
  {
    number: "04",
    icon: Landmark,
    title: "Statutory Compliance",
    description:
      "Fully compliant with all statutory bodies and regulations, so every transaction is legitimate and secure.",
  },
  {
    number: "05",
    icon: ShieldCheck,
    title: "100% Safety & Guarantee",
    description:
      "Your gold and your money are protected end-to-end. We are big on trust — that is our promise.",
  },
  {
    number: "06",
    icon: Timer,
    title: "Quick Evaluation",
    description:
      "A swift, streamlined process valuing your gold in minutes, not hours.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="why" id="why-us">
      <div className="why__header">
        <span className="why__eyebrow">
          <span className="why__eyebrow-line" />
          Why Choose Durga Gold
        </span>

        <h2 className="why__headline">
          Selling gold should feel <span className="why__highlight">royal</span>,
          <br />
          never risky.
        </h2>

        <p className="why__subtext">
          Getting cash for gold must be handled carefully — there is always a
          chance of being deceived. We know this better than anyone, which is
          why every safeguard is built into the way we work.
        </p>
      </div>

      <div className="why__grid">
        {features.map(({ number, icon: Icon, title, description, hasImage }) => (
          <div
            className={`why__card${hasImage ? " why__card--image" : ""}`}
            key={number}
          >
            <div className="why__card-top">
              <Icon className="why__icon" strokeWidth={1.5} />
              <span className="why__number">{number}</span>
            </div>
            <h3 className="why__card-title">{title}</h3>
            <p className="why__card-desc">{description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
